import React, { useState, useEffect } from "react";
import { Box, Grid, Typography, Card, TextField, Button, Checkbox, FormControlLabel, MenuItem, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";

const OlympiadShipmentModal = ({ closePopup, modalData }) => {
    console.log(modalData, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa")
    // const isStudentRegistration = String(modalData?.registration_type) == "2";
    // const isBookOrder = String(modalData?.registration_type) == "3";

    // // ✅ olympiad_type: 1 = MOM, 2 = JPQ, 3 = Both (uses JPQ item set)
    // const olympiadTypeGroup = Number(modalData?.olympiad_type) == 1 ? 1 : 2;
    // const SM_ID = olympiadTypeGroup == 1 ? 1 : 9;       // Study Material id
    // const OTHERS_ID = olympiadTypeGroup == 1 ? 6 : 14;  // Others id
    // const JPQ_ONLY_IDS = [7, 8]; // Coupons, Flash Card — always tied to jpqStudentCount
    const isStudentRegistration = String(modalData?.registration_type) == "2";
    const isBookOrder = String(modalData?.registration_type) == "3";

    // ✅ olympiad_type: 1 = MOM, 2 = JPQ, 3 = Both
    const rawOlympiadType = Number(modalData?.olympiad_type);
    const isBothType = rawOlympiadType === 3;

    // olympiad_type group drives the "base" item set (Study Material/Question Paper/etc).
    // MOM-only uses the type-1 set; JPQ-only AND Both use the type-2 set.
    const olympiadTypeGroup = rawOlympiadType == 1 ? 1 : 2;
    const SM_ID = olympiadTypeGroup == 1 ? 1 : 9;       // Study Material id
    const OTHERS_ID = olympiadTypeGroup == 1 ? 6 : 14;  // Others id

    const JPQ_COUPON_ID = 7;    // "Coupons" tied to JPQ student count
    const FLASH_CARD_ID = 8;    // Flash Card, always tied to jpqStudentCount
    const MOM_COUPON_ID = 15;   // "Coupons" tied to MOM student count

    const JPQ_ONLY_IDS = [JPQ_COUPON_ID, FLASH_CARD_ID]; // driven by jpqStudentCount
    const MOM_ONLY_IDS = [MOM_COUPON_ID];                // driven by momStudentCount
    // ✅ Returns only the items belonging to the current olympiad_type group
    // const getFilteredItemsNameWithId = () => {
    //     return (modalData?.shipmentItemes?.itemsNameWithId || []).filter(
    //         (item) => item.olympiad_type == olympiadTypeGroup
    //     );
    // };

    // const getFilteredItemsNameWithId = () => {
    //     return (modalData?.shipmentItemes?.itemsNameWithId || [])
    //         .filter((item) => item.olympiad_type == olympiadTypeGroup)
    //         .sort((a, b) => (Number(a.sequence) || 0) - (Number(b.sequence) || 0));
    // };

    const getFilteredItemsNameWithId = () => {
        const all = modalData?.shipmentItemes?.itemsNameWithId || [];
        return all
            .filter((item) => {
                if (item.olympiad_type == olympiadTypeGroup) return true;
                // ✅ Both (MOM + JPQ): also pull in the MOM-specific Coupons item
                // (id 15, olympiad_type 1) alongside the JPQ item set, so both
                // coupon types show up separately with their own student counts.
                if (isBothType && item.id == MOM_COUPON_ID) return true;
                return false;
            })
            .sort((a, b) => (Number(a.sequence) || 0) - (Number(b.sequence) || 0));
    };

    // ✅ Unique state key per item — needed now that "Coupons" can appear twice
    // (id 7 for JPQ, id 15 for MOM) sharing the same display name.
    const getItemKey = (item) => `item_${item.id}`;

    // ✅ Disambiguated label — only Coupons ever collides, so tag those two.
    const getItemLabel = (item) => {
        if (item.id == MOM_COUPON_ID) return `${item.name} (MOM)`;
        if (item.id == JPQ_COUPON_ID) return `${item.name} (JPQ)`;
        return item.name;
    };

    const [items, setItems] = useState({});
    const [selectedItems, setSelectedItems] = useState({});
    const [enteredItems, setEnteredItems] = useState({});
    const [step, setStep] = useState(1);
    const [trackingData, setTrackingData] = useState([]);
    const [attachmentData, setAttachmentData] = useState([]);
    const [previewImage, setPreviewImage] = useState(null);
    const [deletedAttachments, setDeletedAttachments] = useState([]);
    const [trackingForm, setTrackingForm] = useState({
        trackingNo: "",
        courier: "",
        dispatchDate: "",
        deliveryDate: "",
        parcelCount: "",
        status: "shipped",
        proof: null
    });
    const [deliveryStatus, setDeliveryStatus] = useState(3);
    // Add this state
    const [selectedStudyMaterial, setSelectedStudyMaterial] = useState({});
    const [enteredStudyMaterial, setEnteredStudyMaterial] = useState({});

    const handleStudyMaterialCheckbox = (classId, maxVal) => {
        setSelectedStudyMaterial((prev) => {
            const newVal = !prev[classId];
            if (newVal) {
                setEnteredStudyMaterial((p) => ({ ...p, [classId]: maxVal }));
            }
            return { ...prev, [classId]: newVal };
        });
    };

    const handleStudyMaterialCount = (classId, value, max) => {
        if (value == "") {
            setEnteredStudyMaterial((p) => ({ ...p, [classId]: "" }));
            return;
        }
        let v = Number(value);
        if (v < 0) v = 0;
        if (v > max) v = max;
        setEnteredStudyMaterial((p) => ({ ...p, [classId]: v }));
    };

    const handleSelectAllStudyMaterial = (selectableItems) => {
        if (!selectableItems || selectableItems.length == 0) return;

        const allSelected = selectableItems.every(({ key }) => !!selectedStudyMaterial[key]);

        if (allSelected) {
            // Deselect all of them
            setSelectedStudyMaterial((prev) => {
                const updated = { ...prev };
                selectableItems.forEach(({ key }) => {
                    updated[key] = false;
                });
                return updated;
            });
        } else {
            // Select all of them and default the entered count to the max remaining
            setSelectedStudyMaterial((prev) => {
                const updated = { ...prev };
                selectableItems.forEach(({ key }) => {
                    updated[key] = true;
                });
                return updated;
            });
            setEnteredStudyMaterial((prev) => {
                const updated = { ...prev };
                selectableItems.forEach(({ key, remaining }) => {
                    updated[key] = remaining;
                });
                return updated;
            });
        }
    };

    const handleTrackingChange = (key, value) => {

        if (key == "status") {
            if (value == "shipped") setDeliveryStatus(3);
            else if (value == "delivered") setDeliveryStatus(4);
        }
        setTrackingForm((prev) => {
            let updated = { ...prev, [key]: value };
            return updated;
        });
    };

    useEffect(() => {
        if (trackingForm.dispatchDate) {
            const dispatch = new Date(trackingForm.dispatchDate);

            const estimated = new Date(dispatch);
            estimated.setDate(dispatch.getDate() + 7);

            const formatted = estimated.toISOString().split("T")[0];

            setTrackingForm((prev) => ({
                ...prev,
                deliveryDate: formatted
            }));
        }
    }, [trackingForm.dispatchDate]);

    const handleRemoveAttachment = (index) => {
        const isSuccess = window.confirm("Are you sure you want to delete this image?");

        if (!isSuccess) return;

        setAttachmentData((prev) => {
            const removed = prev[index];

            if (!removed.file) {
                setDeletedAttachments((d) => [...d, removed]);
            }

            return prev.filter((_, i) => i !== index);
        });
    };

    // useEffect(() => {
    //     if (modalData?.shipmentItemes?.itemsNameWithId) {
    //         const initialItems = {};
    //         getFilteredItemsNameWithId().forEach((item) => {
    //             const shipped = getAlreadyShippedCount(item.id);
    //             if (item.id == SM_ID) {
    //                 // SM handled separately
    //             } else if (item.id == OTHERS_ID) {
    //                 initialItems[item.name] = 0;
    //             } else {
    //                 const total = modalData?.shipmentItemes?.totalStudent || 0;
    //                 initialItems[item.name] = Math.max(0, total - shipped);
    //             }
    //         });
    //         setItems(initialItems);
    //     }
    // }, [modalData]);

    //     useEffect(() => {
    //     if (modalData?.shipmentItemes?.itemsNameWithId) {
    //         const initialItems = {};
    //         getFilteredItemsNameWithId().forEach((item) => {
    //             const shipped = getAlreadyShippedCount(item.id);
    //             if (item.id == SM_ID) {
    //                 // SM handled separately
    //             } else if (item.id == OTHERS_ID) {
    //                 initialItems[item.name] = 0;
    //             } else if (JPQ_ONLY_IDS.includes(item.id)) {
    //                 const total = modalData?.shipmentItemes?.jpqStudentCount || 0;
    //                 initialItems[item.name] = Math.max(0, total - shipped);
    //             } else {
    //                 const total = modalData?.shipmentItemes?.totalStudent || 0;
    //                 initialItems[item.name] = Math.max(0, total - shipped);
    //             }
    //         });
    //         setItems(initialItems);
    //     }
    // }, [modalData]);

    useEffect(() => {
        if (modalData?.shipmentItemes?.itemsNameWithId) {
            const initialItems = {};
            getFilteredItemsNameWithId().forEach((item) => {
                const key = getItemKey(item);
                const shipped = getAlreadyShippedCount(item.id);
                if (item.id == SM_ID) {
                    // SM handled separately
                } else if (item.id == OTHERS_ID) {
                    initialItems[key] = 0;
                } else if (JPQ_ONLY_IDS.includes(item.id)) {
                    const total = modalData?.shipmentItemes?.jpqStudentCount || 0;
                    initialItems[key] = Math.max(0, total - shipped);
                } else if (MOM_ONLY_IDS.includes(item.id)) {
                    const total = modalData?.shipmentItemes?.momStudentCount || 0;
                    initialItems[key] = Math.max(0, total - shipped);
                } else {
                    const total = modalData?.shipmentItemes?.totalStudent || 0;
                    initialItems[key] = Math.max(0, total - shipped);
                }
            });
            setItems(initialItems);
        }
    }, [modalData]);


    // const handleChange = (key, value) => {
    //     if (key == "Others") {
    //         setEnteredItems((prev) => ({
    //             ...prev,
    //             [key]: value,
    //         }));
    //         return;
    //     }

    //     const maxValue = items[key] || 0;

    //     if (value == "") {
    //         setEnteredItems((prev) => ({
    //             ...prev,
    //             [key]: "",
    //         }));
    //         return;
    //     }

    //     let finalValue = Number(value);

    //     if (finalValue < 0) finalValue = 0;
    //     if (finalValue > maxValue) finalValue = maxValue;

    //     setEnteredItems((prev) => ({
    //         ...prev,
    //         [key]: finalValue,
    //     }));
    // };
    const handleChange = (key, value, isOthers) => {
        if (isOthers) {
            setEnteredItems((prev) => ({
                ...prev,
                [key]: value,
            }));
            return;
        }

        const maxValue = items[key] || 0;

        if (value == "") {
            setEnteredItems((prev) => ({
                ...prev,
                [key]: "",
            }));
            return;
        }

        let finalValue = Number(value);

        if (finalValue < 0) finalValue = 0;
        if (finalValue > maxValue) finalValue = maxValue;

        setEnteredItems((prev) => ({
            ...prev,
            [key]: finalValue,
        }));
    };

    const handleCheckboxChange = (name) => {
        setSelectedItems((prev) => {
            const newValue = !prev[name];

            if (newValue) {
                setEnteredItems((prevEntered) => ({
                    ...prevEntered,
                    [name]: items[name] == 0 ? "" : items[name]
                }));
            }

            return {
                ...prev,
                [name]: newValue,
            };
        });
    };

    // const handleAddTracking = () => {

    //     const selectedKeys = Object.keys(selectedItems).filter((key) => selectedItems[key]);
    //     const selectedSMKeys = Object.keys(selectedStudyMaterial).filter(
    //         (key) => selectedStudyMaterial[key]
    //     );

    //     if (selectedKeys.length == 0 && selectedSMKeys.length == 0) {
    //         alert("Please select at least one item");
    //         return;
    //     }

    //     // Validate non-SM items
    //     for (let key of selectedKeys) {
    //         const value = enteredItems[key];
    //         const isOthers = getFilteredItemsNameWithId().find(
    //             (i) => i.name == key
    //         )?.id == OTHERS_ID;
    //         if (isOthers) {
    //             if (!value || value.trim() == "") { alert("Please enter value for Others"); return; }
    //         } else {
    //             if (!value || Number(value) <= 0) { alert(`Please enter valid count for ${key}`); return; }
    //         }
    //     }

    //     // Validate SM items
    //     for (let key of selectedSMKeys) {
    //         const value = enteredStudyMaterial[key];
    //         if (!value || Number(value) <= 0) {
    //             const cls = modalData?.lineItems?.find((l) => key.startsWith(`SM_${l.classId}`));
    //             alert(`Please enter valid count for Study Material - ${cls?.className || key}`);
    //             return;
    //         }
    //     }

    //     // Build regular items
    //     const regularData = selectedKeys.map((key) => {
    //         const itemObj = getFilteredItemsNameWithId().find((i) => i.name == key);
    //         return {
    //             id: itemObj?.id,
    //             name: key,
    //             count: key == "Others" ? enteredItems[key] || "" : enteredItems[key] || 0
    //         };
    //     });

    //     // Build class-wise SM items
    //     const smData = selectedSMKeys.map((key) => {
    //         const lineItem = modalData?.lineItems?.find((l) => key == `SM_${l.classId}_${l.subjectId}`);
    //         return {
    //             id: SM_ID, // Study Material id
    //             name: `Study Material`,
    //             className: lineItem?.className,
    //             classId: lineItem?.classId,
    //             subjectId: lineItem?.subjectId,
    //             count: enteredStudyMaterial[key] || 0
    //         };
    //     });

    //     setTrackingData([...smData, ...regularData]);
    //     setStep(2);
    // };

    const handleAddTracking = () => {
        const selectedKeys = Object.keys(selectedItems).filter((key) => selectedItems[key]);
        const selectedSMKeys = Object.keys(selectedStudyMaterial).filter(
            (key) => selectedStudyMaterial[key]
        );

        if (selectedKeys.length == 0 && selectedSMKeys.length == 0) {
            alert("Please select at least one item");
            return;
        }

        // Validate non-SM items
        for (let key of selectedKeys) {
            const value = enteredItems[key];
            const itemObj = getFilteredItemsNameWithId().find((i) => getItemKey(i) == key);
            const isOthers = itemObj?.id == OTHERS_ID;
            if (isOthers) {
                if (!value || value.trim() == "") { alert("Please enter value for Others"); return; }
            } else {
                if (!value || Number(value) <= 0) {
                    alert(`Please enter valid count for ${getItemLabel(itemObj || {})}`);
                    return;
                }
            }
        }

        // Validate SM items (unchanged)
        for (let key of selectedSMKeys) {
            const value = enteredStudyMaterial[key];
            if (!value || Number(value) <= 0) {
                const cls = modalData?.lineItems?.find((l) => key.startsWith(`SM_${l.classId}`));
                alert(`Please enter valid count for Study Material - ${cls?.className || key}`);
                return;
            }
        }

        // Build regular items — send the real DB name ("Coupons"), not the (MOM)/(JPQ) label
        const regularData = selectedKeys.map((key) => {
            const itemObj = getFilteredItemsNameWithId().find((i) => getItemKey(i) == key);
            return {
                id: itemObj?.id,
                name: itemObj?.name,
                count: itemObj?.id == OTHERS_ID ? enteredItems[key] || "" : enteredItems[key] || 0
            };
        });

        // Build class-wise SM items (unchanged)
        const smData = selectedSMKeys.map((key) => {
            const lineItem = modalData?.lineItems?.find((l) => key == `SM_${l.classId}_${l.subjectId}`);
            return {
                id: SM_ID,
                name: `Study Material`,
                className: lineItem?.className,
                classId: lineItem?.classId,
                subjectId: lineItem?.subjectId,
                count: enteredStudyMaterial[key] || 0
            };
        });

        setTrackingData([...smData, ...regularData]);
        setStep(2);
    };

    const submitFinalTracking = async () => {
        if (!trackingForm.trackingNo?.trim()) {
            window.alert("Tracking Number Must be entered");
            return;
        }
        if (!trackingForm.courier?.trim()) {
            window.alert("Enter Courier");
            return;
        }
        if (!trackingForm.status?.trim()) {
            window.alert("Please Fill Delivery Status");
            return;
        }
        if (!trackingForm.dispatchDate?.trim()) {
            window.alert("Please Fill Dispatch Date");
            return;
        }
        if (!trackingForm.deliveryDate?.trim()) {
            window.alert("Please Fill Delivery Date");
            return;
        }
        if (!trackingForm.parcelCount?.trim()) {
            window.alert("Enter Parcel Count");
            return;
        }
        if (attachmentData?.length <= 0) {
            window.alert("Please Uplaoad Attachemnt");
            return;
        }
        const filteredTrackingData = trackingData.filter(
            (item) => item.name !== "Others"
        );

        const allZero = filteredTrackingData.every(
            (item) => Number(item.count || 0) == 0
        );

        let deliveryStatus;

        if (allZero) {
            deliveryStatus = trackingForm.status == "delivered" ? 4 : 3;
        } else {
            if (trackingForm.status == "shipped") {
                deliveryStatus = 3
            }
            else if (trackingForm.status == "delivered") {
                deliveryStatus = 8
            }

        }

        const formData = new FormData();

        attachmentData.forEach((fileObj) => {
            if (fileObj.file instanceof File) {
                formData.append("files", fileObj.file);
            }
        });

        formData.append("regId", modalData?.regId);
        formData.append("deliveryStatus", deliveryStatus);

        formData.append("items", JSON.stringify(trackingData));
        formData.append("tracking", JSON.stringify(trackingForm));
        formData.append("olympiad_type", modalData?.olympiad_type);

        try {
            const res = await window.Platform.database.createShipment(formData);

            if (res.status) {
                window.NotificationUtils.showSuccess(res?.message || "Successfully Done");
                closePopup();
            } else {
                window.NotificationUtils.showError(res?.message || "Something went wrong");
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("API Failed");
        }
    };

    useEffect(() => {
        return () => {
            attachmentData.forEach(att => {
                if (att.file) URL.revokeObjectURL(att.preview);
            });
        };
    }, [attachmentData]);

    const formatDate = (date) => {
        if (!date) return "-";

        return new Date(date).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    const getAlreadyShippedCount = (itemId) => {
        let total = 0;
        modalData?.shipmentDetails?.forEach((shipment) => {
            shipment?.items?.forEach((item) => {
                if (String(item.item_id) == String(itemId)) {
                    total += Number(item.count || 0);
                }
            });
        });
        return total;
    };

    return (
        <Box p={3}>
            <IconButton
                onClick={closePopup}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 8
                }}
            >
                <CloseIcon />
            </IconButton>
            {step == 1 ? <>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: "20px", fontWeight: "600", marginBottom: "10px" }}>
                    Item Shipment ({modalData?.rno_id})
                </div>
                <Card sx={{ p: 3, mb: 3, background: "#e8f5e9" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <p> School name: -   ({modalData?.partyId || ""}) {modalData?.schoolName || "N/A"}</p>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <p> RM name: -  ({modalData?.userId || ""}) {modalData?.userName || "N/A"}</p>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <p> Date Of Olympiad: -   {formatDate(modalData?.olympiad_date)}</p>
                        </Grid>

                        <Grid item xs={12} md={6} sx={{ display: "flex" }}>
                            {modalData?.shipmentItemes?.momStudentCount > 0 && <p>
                                Total Students MOM: {
                                    isBookOrder
                                        ? 0
                                        : modalData?.shipmentItemes?.momStudentCount || 0
                                }
                            </p>}
                            {modalData?.shipmentItemes?.jpqStudentCount > 0 && <span style={{ borderRight: "2px solid black", paddingRight: "10px", height: "17px" }}></span>}
                            {modalData?.shipmentItemes?.jpqStudentCount > 0 && <p style={{ marginLeft: "10px" }}>
                                Total Students JPQ: {
                                    isBookOrder
                                        ? 0
                                        : modalData?.shipmentItemes?.jpqStudentCount || 0
                                }
                            </p>}
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <p> Medium: -   {modalData?.reg_medium_name || "N/A"}</p>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <p>
                                Total Books: - {
                                    isStudentRegistration
                                        ? 0
                                        : modalData?.shipmentItemes?.totalStudyMaterial || 0
                                }
                            </p>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <p> Registration Type: -  {modalData?.RegistrationType || "N/A"}</p>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <p> Olympiad Type: -  {modalData?.olympiad_type_name || "N/A"}</p>
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <p>
                                Classes Opted: -
                                {
                                    modalData?.lineItems?.length
                                        ? [...new Set(modalData.lineItems.map(item => item.className))]
                                            .sort((a, b) => {
                                                const numA = parseInt(a.replace(/\D/g, ""));
                                                const numB = parseInt(b.replace(/\D/g, ""));
                                                return numA - numB;
                                            })
                                            .join(", ")
                                        : "N/A"
                                }
                            </p>
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <p>
                                Subjects Opted: -
                                {
                                    modalData?.lineItems?.length
                                        ? [...new Set(modalData.lineItems.map(item => item.subjectName))].join(", ")
                                        : "N/A"
                                }
                            </p>
                        </Grid>
                    </Grid>
                </Card>
                <Grid container spacing={2}>
                    {getFilteredItemsNameWithId().map((item) => {
                        // ✅ Special handling for Study Material (SM_ID: 1 for MOM, 9 for JPQ/Both)
                        if (item.id == SM_ID) {
                            if (isStudentRegistration) {
                                return null;
                            }

                            // Precompute shipped/remaining for every class+subject line item
                            let remainingToDistribute = getAlreadyShippedCount(SM_ID);
                            const smLineItemsWithRemaining = (modalData?.lineItems || []).map((lineItem) => {
                                const key = `SM_${lineItem.classId}_${lineItem.subjectId}`;
                                const total = lineItem.study_material || 0;

                                const shipped = Math.min(remainingToDistribute, total);
                                remainingToDistribute -= shipped;
                                const remaining = total - shipped;

                                return { lineItem, key, total, shipped, remaining };
                            });

                            // Only items that still have something left to ship are selectable
                            const selectableSMItems = smLineItemsWithRemaining.filter((r) => r.remaining > 0);

                            const allSMSelected =
                                selectableSMItems.length > 0 &&
                                selectableSMItems.every((r) => !!selectedStudyMaterial[r.key]);
                            const someSMSelected = selectableSMItems.some((r) => !!selectedStudyMaterial[r.key]);

                            return (
                                <Grid item xs={12} sm={6} md={4} key={item.id}>
                                    <Card sx={{ p: 2 }}>
                                        <Box display="flex" alignItems="center" justifyContent="space-between">
                                            <Typography fontWeight="bold">{item.name}</Typography>
                                            {selectableSMItems.length > 0 && (
                                                <FormControlLabel
                                                    sx={{ mr: 0 }}
                                                    control={
                                                        <Checkbox
                                                            size="small"
                                                            checked={allSMSelected}
                                                            indeterminate={!allSMSelected && someSMSelected}
                                                            onChange={() => handleSelectAllStudyMaterial(selectableSMItems)}
                                                        />
                                                    }
                                                    label={<Typography variant="body2">Select All</Typography>}
                                                />
                                            )}
                                        </Box>
                                        {smLineItemsWithRemaining.map(({ lineItem, key, total, shipped, remaining }) => {
                                            return (
                                                <Box key={key} mt={1}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={!!selectedStudyMaterial[key]}
                                                                onChange={() =>
                                                                    remaining > 0
                                                                        ? handleStudyMaterialCheckbox(key, remaining)
                                                                        : null
                                                                }
                                                                disabled={remaining == 0}
                                                            />
                                                        }
                                                        label={
                                                            <span>
                                                                {lineItem.className} - {lineItem.subjectName} ({total})
                                                                {shipped > 0 && (
                                                                    <span style={{ color: "#f57c00", fontSize: "12px", marginLeft: "6px" }}>
                                                                        [{shipped} shipped]
                                                                    </span>
                                                                )}
                                                            </span>
                                                        }
                                                    />
                                                    {remaining == 0 ? (
                                                        <Typography
                                                            variant="caption"
                                                            sx={{
                                                                color: "green",
                                                                display: "block",
                                                                ml: 1,
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            ✅ Already Fully Shipped
                                                        </Typography>
                                                    ) : (
                                                        selectedStudyMaterial[key] && (
                                                            <TextField
                                                                label="Enter Delivery Count"
                                                                type="number"
                                                                size="small"
                                                                fullWidth
                                                                inputProps={{ min: 0, max: remaining }}
                                                                onWheel={(e) => e.target.blur()}
                                                                value={enteredStudyMaterial[key] ?? ""}
                                                                onChange={(e) =>
                                                                    handleStudyMaterialCount(key, e.target.value, remaining)
                                                                }
                                                                sx={{ mt: 1 }}
                                                            />
                                                        )
                                                    )}
                                                </Box>
                                            );
                                        })}
                                    </Card>
                                </Grid>
                            );
                        }

                        // if (isBookOrder && item.id !== SM_ID && item.id !== OTHERS_ID) {
                        //     return null;
                        // }

                        // // const alreadyShipped = getAlreadyShippedCount(item.id);
                        // // const totalCount = item.id == OTHERS_ID ? 0 : modalData?.shipmentItemes?.totalStudent || 0;
                        // // const remainingCount = Math.max(0, totalCount - alreadyShipped);

                        // const alreadyShipped = getAlreadyShippedCount(item.id);

                        // const totalCount = item.id == OTHERS_ID
                        //     ? 0
                        //     : JPQ_ONLY_IDS.includes(item.id)
                        //         ? modalData?.shipmentItemes?.jpqStudentCount || 0
                        //         : modalData?.shipmentItemes?.totalStudent || 0;

                        // const remainingCount = Math.max(0, totalCount - alreadyShipped);


                        // return (
                        //     <Grid item xs={12} sm={6} md={4} key={item.id}>
                        //         <Card sx={{ p: 2 }}>
                        //             <Typography fontWeight="bold">{item.name}</Typography>
                        //             <FormControlLabel
                        //                 control={
                        //                     <Checkbox
                        //                         checked={!!selectedItems[item.name]}
                        //                         onChange={() =>
                        //                             remainingCount > 0 || item.id == OTHERS_ID
                        //                                 ? handleCheckboxChange(item.name)
                        //                                 : null
                        //                         }
                        //                         disabled={remainingCount == 0 && item.id !== OTHERS_ID}
                        //                     />
                        //                 }
                        //                 label={
                        //                     <span>
                        //                         {item.name} ({item.id == OTHERS_ID ? 0 : totalCount})
                        //                         {alreadyShipped > 0 && item.id !== OTHERS_ID && (
                        //                             <span style={{ color: "#f57c00", fontSize: "12px", marginLeft: "6px" }}>
                        //                                 [{alreadyShipped} shipped]
                        //                             </span>
                        //                         )}
                        //                     </span>
                        //                 }
                        //             />
                        //             {remainingCount == 0 && item.id !== OTHERS_ID ? (
                        //                 <Typography
                        //                     variant="caption"
                        //                     sx={{ color: "green", display: "block", ml: 1, fontWeight: 600 }}
                        //                 >
                        //                     ✅ Already Fully Shipped
                        //                 </Typography>
                        //             ) : (
                        //                 selectedItems[item.name] && (
                        //                     <TextField
                        //                         label={item.id == OTHERS_ID ? "Enter Item (e.g. Chalk 12)" : "Enter Delivery Count"}
                        //                         type={item.id == OTHERS_ID ? "text" : "number"}
                        //                         size="small"
                        //                         fullWidth
                        //                         inputProps={
                        //                             item.id == OTHERS_ID
                        //                                 ? {}
                        //                                 : { min: 0, max: remainingCount }
                        //                         }
                        //                         onWheel={(e) => e.target.blur()}
                        //                         value={enteredItems[item.name] ?? ""}
                        //                         onChange={(e) => handleChange(item.name, e.target.value)}
                        //                         sx={{ mt: 1 }}
                        //                     />
                        //                 )
                        //             )}
                        //         </Card>
                        //     </Grid>
                        // );
                        if (isBookOrder && item.id !== SM_ID && item.id !== OTHERS_ID) {
                            return null;
                        }

                        const key = getItemKey(item);
                        const label = getItemLabel(item);

                        const alreadyShipped = getAlreadyShippedCount(item.id);

                        const totalCount = item.id == OTHERS_ID
                            ? 0
                            : JPQ_ONLY_IDS.includes(item.id)
                                ? modalData?.shipmentItemes?.jpqStudentCount || 0
                                : MOM_ONLY_IDS.includes(item.id)
                                    ? modalData?.shipmentItemes?.momStudentCount || 0
                                    : modalData?.shipmentItemes?.totalStudent || 0;

                        const remainingCount = Math.max(0, totalCount - alreadyShipped);

                        return (
                            <Grid item xs={12} sm={6} md={4} key={item.id}>
                                <Card sx={{ p: 2 }}>
                                    <Typography fontWeight="bold">{label}</Typography>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={!!selectedItems[key]}
                                                onChange={() =>
                                                    remainingCount > 0 || item.id == OTHERS_ID
                                                        ? handleCheckboxChange(key)
                                                        : null
                                                }
                                                disabled={remainingCount == 0 && item.id !== OTHERS_ID}
                                            />
                                        }
                                        label={
                                            <span>
                                                {label} ({item.id == OTHERS_ID ? 0 : totalCount})
                                                {alreadyShipped > 0 && item.id !== OTHERS_ID && (
                                                    <span style={{ color: "#f57c00", fontSize: "12px", marginLeft: "6px" }}>
                                                        [{alreadyShipped} shipped]
                                                    </span>
                                                )}
                                            </span>
                                        }
                                    />
                                    {remainingCount == 0 && item.id !== OTHERS_ID ? (
                                        <Typography variant="caption" sx={{ color: "green", display: "block", ml: 1, fontWeight: 600 }}>
                                            ✅ Already Fully Shipped
                                        </Typography>
                                    ) : (
                                        selectedItems[key] && (
                                            <TextField
                                                label={item.id == OTHERS_ID ? "Enter Item (e.g. Chalk 12)" : "Enter Delivery Count"}
                                                type={item.id == OTHERS_ID ? "text" : "number"}
                                                size="small"
                                                fullWidth
                                                inputProps={item.id == OTHERS_ID ? {} : { min: 0, max: remainingCount }}
                                                onWheel={(e) => e.target.blur()}
                                                value={enteredItems[key] ?? ""}
                                                onChange={(e) => handleChange(key, e.target.value, item.id == OTHERS_ID)}
                                                sx={{ mt: 1 }}
                                            />
                                        )
                                    )}
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
                <Box mt={3} display="flex" gap={2}>
                    <Button variant="contained" onClick={handleAddTracking} alignItems="center">
                        Add Tracking Detail
                    </Button>
                </Box>
            </>
                :
                <Box p={3}>
                    <Typography variant="h6" mb={2}>
                        Update Tracking Details
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Tracking No."
                                fullWidth
                                size="small"
                                value={trackingForm.trackingNo}
                                onChange={(e) => handleTrackingChange("trackingNo", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Courier"
                                fullWidth
                                size="small"
                                value={trackingForm.courier}
                                onChange={(e) => handleTrackingChange("courier", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <TextField
                                label="Delivery Status"
                                select
                                fullWidth
                                disabled
                                size="small"
                                value={trackingForm.status}
                                onChange={(e) => { handleTrackingChange("status", e.target.value) }}
                            >
                                <MenuItem value="shipped">Shipped</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Dispatch Date"
                                type="date"
                                fullWidth
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                value={trackingForm.dispatchDate}
                                onChange={(e) => handleTrackingChange("dispatchDate", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Estimated Delivery Date"
                                type="date"
                                fullWidth
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                inputProps={{
                                    min: trackingForm.dispatchDate || new Date().toISOString().split("T")[0]
                                }}
                                value={trackingForm.deliveryDate}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    if (trackingForm.dispatchDate && value < trackingForm.dispatchDate) {
                                        alert("Delivery date cannot be before dispatch date");
                                        return;
                                    }

                                    handleTrackingChange("deliveryDate", value);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Parcel Count"
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                fullWidth
                                size="small"
                                value={trackingForm.parcelCount}
                                onChange={(e) => handleTrackingChange("parcelCount", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="outlined" component="label">
                                Upload Attachment
                                <input
                                    type="file"
                                    multiple
                                    hidden
                                    onChange={(e) => {
                                        const files = Array.from(e.target.files);

                                        const mappedFiles = files.map((file) => ({
                                            file: file,
                                            name: file.name,
                                            path: `${window.Platform.database.funcForBaseURL()}/file/${file.name}`
                                        }));

                                        setAttachmentData((prev) => [...prev, ...mappedFiles]);
                                    }}
                                />
                            </Button>
                            {attachmentData.length > 0 && (
                                <Box mt={1}>
                                    <Grid container spacing={2} mt={1}>
                                        {attachmentData.map((att, i) => {
                                            const imageUrl = att.file
                                                ? URL.createObjectURL(att.file)
                                                : `${window.Platform.database.funcForBaseURL()}/file/${att.name}`;

                                            return (
                                                <Grid item xs={3} key={i}>
                                                    <Box textAlign="center">
                                                        <DeleteIcon
                                                            onClick={() => handleRemoveAttachment(i)}
                                                            style={{
                                                                position: "absolute",
                                                                cursor: "pointer",
                                                                color: "#d90000",
                                                                background: "#fff",
                                                                borderRadius: "50%"
                                                            }}
                                                        />
                                                        <img
                                                            src={imageUrl}
                                                            alt={att.name}
                                                            onClick={() => setPreviewImage(imageUrl)}
                                                            style={{
                                                                width: "100%",
                                                                height: "120px",
                                                                objectFit: "cover",
                                                                borderRadius: "8px",
                                                                cursor: "pointer",
                                                                border: "1px solid #ccc"
                                                            }}
                                                        />
                                                        <Typography variant="caption">
                                                            {att.name}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </Box>
                            )}
                        </Grid>
                    </Grid>
                    <Box mt={3} display="flex" gap={2}>
                        <Button variant="outlined" onClick={() => setStep(1)}>
                            Back
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => { submitFinalTracking() }}
                        >
                            Submit
                        </Button>
                    </Box>
                </Box>
            }
            <Box display="flex" justifyContent="center" mt={2}>
                <Typography fontWeight="bold">
                    Step {step} of 2
                </Typography>
            </Box>
        </Box>
    );
};

export default OlympiadShipmentModal;